import axios from 'axios';
import useSWR from 'swr';

const useAiAgents = () => {
  const url = '/admin/ai-agent';
  const swr = useSWR(url, async (url) => {
    try {
      const result = await axios.get(url);
      return result.data;
    } catch (err) {
      throw Error(err);
    }
  });

  return swr;
};

const useCompanyAiAgents = (companyUid, context) => {
  const url = `/admin/company/${companyUid}/ai-agent?context=${context}`;
  const swr = useSWR(url, async (url) => {
    try {
      const result = await axios.get(url);
      return result.data;
    } catch (err) {
      throw Error(err);
    }
  });

  return swr;
};

const usePutCompanyAiAgent = () => {
  const putCompanyAiAgent = async (uid, payload) => {
    try {
      const url = `/admin/company-ai-agent/${uid}`;
      const result = await axios.put(url, payload);
      return result.data;
    } catch (err) {
      throw Error(err);
    }
  };
  return putCompanyAiAgent;
};

export { useAiAgents, useCompanyAiAgents, usePutCompanyAiAgent };
